var _Loader;
import { Loader } from "@crehana/ui";
import { jsx as _jsx } from "react/jsx-runtime";
var CurrencyLoader = function CurrencyLoader(_ref) {
  var isDark = _ref.isDark;
  return /*#__PURE__*/_jsx("div", {
    className: "rounded-5 h-56 flex items-center justify-center ".concat(isDark ? 'bg-base-lighter-dark-mode' : 'bg-gray-light'),
    style: {
      width: 260
    },
    children: _Loader || (_Loader = /*#__PURE__*/_jsx(Loader, {
      size: 24
    }))
  });
};
export default CurrencyLoader;